module.exports = __webpack_public_path__ + "static/media/tyre-low.8c020658.png";